import script from "./ProductionDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionDashboard.vue?vue&type=script&setup=true&lang=js"

import "./ProductionDashboard.vue?vue&type=style&index=0&id=5b3fbc03&lang=scss"

const __exports__ = script;

export default __exports__